import { render, staticRenderFns } from "./investDetail.vue?vue&type=template&id=1c93a5ca"
import script from "./investDetail.vue?vue&type=script&lang=js"
export * from "./investDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports